import { render, staticRenderFns } from "./contact-info-popup.vue?vue&type=template&id=05a25c72"
import script from "./contact-info-popup.vue?vue&type=script&lang=js"
export * from "./contact-info-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports